import "./ManageCacheItemPage.scss";

import React, { useCallback } from "react";
import { CardBody } from "react-bootstrap";
import { NavLink, Route, Routes } from "react-router-dom";

import type { IOrganization } from "../../../../contexts/organizations/organizationsContext";
import type {
  ICacheItemResponsePayload,
  IPromptContext,
  IPrompType,
  ISimilarPrompt,
} from "../../../../hooks/reactQueryHooks/useCacheItems";
import type { Message } from "../../../../hooks/reactQueryHooks/useRequests";
import { PromptAndAnswerTab } from "../PromptAndAnswerTab/PromptAndAnswerTab";
import { RequestsTab } from "../RequestsTab/RequestsTab";

export interface IProps {
  cacheData: ICacheItemResponsePayload | null;
  appName: string;
  projId: string;
  cacheId: string;
  similarPrompts: ISimilarPrompt[];
  currentOrganization: IOrganization | null;
  fetchItem: () => void;
  promptContext?: IPromptContext;
  promptType?: IPrompType;
  cacheHistory: Message[];
}

export const ManageCacheItemPage: React.FC<IProps> = ({
  cacheData,
  appName,
  projId,
  similarPrompts,
  cacheId,
  currentOrganization,
  fetchItem,
  promptContext,
  promptType,
  cacheHistory,
}) => {
  const fetchCacheItem = useCallback(() => {
    fetchItem();
  }, [fetchItem]);

  return (
    <div className="manage-cache-item-page">
      <div className="manage-cache-item-page__nav d-flex align-items-center justify-content-start">
        <NavLink
          to={`/safety-compliance/cache/${projId}/${cacheId?.replaceAll(
            " ",
            "%20",
          )}`}
          end
          onClick={fetchCacheItem}
        >
          Prompt and answer
        </NavLink>
        <NavLink
          to={`/safety-compliance/cache/${projId}/${cacheId?.replaceAll(
            " ",
            "%20",
          )}/requests?columns=completionTokens,promptTokens,cost`}
        >
          Requests
        </NavLink>
        {/* <NavLink
          to={`/safety-compliance/cache/${id?.replaceAll(' ', '%20')}/analytics`}
          className="btn"
        >
          Analytics
        </NavLink> */}
      </div>

      <div className="card d-flex flex-column">
        <CardBody>
          <Routes>
            <Route
              path="/"
              element={
                <PromptAndAnswerTab
                  id={cacheId || ""}
                  cacheData={cacheData}
                  appName={appName}
                  similarPrompts={similarPrompts}
                  projId={projId}
                  promptContext={promptContext}
                  promptType={promptType}
                  cacheHistory={cacheHistory}
                />
              }
            />
            {/* <Route
              path="/analytics"
              element={<AnalyticsTab />}
            />
             */}
            <Route
              path="/requests"
              element={
                <RequestsTab
                  projId={projId}
                  cacheId={cacheId}
                  currentOrganization={currentOrganization}
                />
              }
            />
          </Routes>
        </CardBody>
      </div>
    </div>
  );
};
